import { render, staticRenderFns } from "./BulkTagMetadata.vue?vue&type=template&id=48d92290&scoped=true"
import script from "./BulkTagMetadata.vue?vue&type=script&lang=js"
export * from "./BulkTagMetadata.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./BulkTagMetadata.vue?vue&type=style&index=1&id=48d92290&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d92290",
  null
  
)

export default component.exports